import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";
import config from "@/config";
import { LMSAuthService } from "./lms_auth";

export const LMSDataService = {
    client: wretch(config.LMS_BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.LMS_BACKEND_URL], {
        credentials: "include",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .middlewares([
            next => async (url, opts) => {
                let tokens = LMSAuthService.get_tokens();
                const csrf = LMSAuthService.get_csrf();

                // Récupère le user courant depuis le localStorage
                const userRaw = localStorage.getItem("current_user");
                if (userRaw) {
                    const user = JSON.parse(userRaw);
                    // Si le token LMS est expiré, on le refresh avec le lms_refresh_token du user
                    if (user.lms_refresh_token && LMSAuthService.has_access_expires()) {
                        await LMSAuthService.refresh(user.lms_refresh_token);
                        tokens = LMSAuthService.get_tokens();
                    }

                    try {
                        const u = JSON.parse(userRaw) as { user_jwt?: string | null };
                        if (u.user_jwt) {
                            //@ts-ignore
                            opts.headers["X-Crm-User-Jwt"] = u.user_jwt;
                        }
                    } catch {
                        /* ignore */
                    }
                }

                if (tokens) {
                    //@ts-ignore
                    opts.headers.Authorization = `Bearer ${tokens.access}`;
                }

                if (csrf) {
                    //@ts-ignore
                    opts.headers["X-CSRFToken"] = csrf;
                }
                return next(url, opts);
            }
        ])
        .addon(QueryStringAddon)
};
